import useDriversPersonalConfigurations from '../../vehicle-offers-list-component/hooks/react-query/use-drivers-personal-configurations';
import React from 'react';
import { Configuration } from '../../vehicle-offers-list-component/hooks/react-query/use-drivers-personal-configurations/use-drivers-personal-configurations.types';
import SelectConfigurationToDeactivate from '../../vehicle-offers-list-component/select-configuration-to-deactivate';
import { toggleModal } from '../../../actions/app_action';
import { MODAL_NAMES, MODALS } from '../../../constants';
import { AlertData } from '../../alert/alert-view';
import { useDispatch } from 'react-redux';
import { CheckDriversCarsProps } from '../configuration-from-pdf.types';

const useCheckDriversCars = (refreshList: () => void) => {
  const dispatch = useDispatch();
  const { getDriversPersonalConfigurations } = useDriversPersonalConfigurations(null);

  const closeAlert = () => {
    dispatch(toggleModal(MODALS.additional_dialog, null));
  };

  const openAlert = (alertData: AlertData) => {
    dispatch(toggleModal(MODALS.additional_dialog, MODAL_NAMES.additional_dialog, alertData));
  };

  const openSelectConfigurationToDeactivateDialog = (configurations: Configuration[], callback: () => void) => {
    const alertData = {
      title: 'Max. Anzahl an Konfigurationen erreicht',
      children: (
        <SelectConfigurationToDeactivate
          closeDialog={closeAlert}
          configurations={configurations}
          callback={callback}
          refreshList={refreshList}
        />
      ),
      allButtonsHidden: true,
      buttons: [
        {
          type: 'cancel',
          title: 'Abbrechen',
          action: closeAlert
        }
      ]
    };

    openAlert(alertData);
  };

  const checkDriversCars = async ({
    driverId,
    successCallback,
    setMaxConfigurationsNumberReached
  }: CheckDriversCarsProps) => {
    const driversCars = await getDriversPersonalConfigurations(driverId);

    if (!driversCars) {
      return;
    }
    if (driversCars.every(car => !car.canBeArchived)) {
      setMaxConfigurationsNumberReached && setMaxConfigurationsNumberReached();
    }
    if (driversCars.length >= MAX_NUMBER_OF_CONFIGURATIONS) {
      openSelectConfigurationToDeactivateDialog(driversCars, successCallback);
    } else {
      successCallback();
    }
  };

  return { checkDriversCars };
};

const MAX_NUMBER_OF_CONFIGURATIONS = 3;

export default useCheckDriversCars;
